import { KatIcon } from '@amzn/katal-react';
import React, { ReactElement } from 'react';
import LogoutIcon from '../../../images/logoutIcon';
import UserName from '../items/UserName';
import UserAvatar from '../items/UserAvatar';
import { MenuConstants } from 'src/constants/ProjectConstants';
import LanguagePicker from 'src/components/LanguagePicker/LanguagePicker';
import { AuthUrlGeneration } from 'src/routes/helpers/AuthenticatedRoute';

export enum QuickLinkType {
  KAT_ICON = 'kat-icon',
  DROPDOWN = 'dropdown',
  SVG = 'svg',
  CUSTOM = 'custom',
}

export type QuickLinkKatIcon = {
  id: string; //used for specfying keys in lists. Should be unique
  type: QuickLinkType.KAT_ICON;
  iconName: KatIcon.Name;
  size?: KatIcon.Size;
  onClick?: (...params) => void;
  description?: string;
  hidden?: boolean;
};

export type QuickLinkSvg = {
  id: string; //used for specfying keys in lists. Should be unique
  type: QuickLinkType.SVG;
  icon: ReactElement;
  onClick?: (...params) => void;
  description?: string;
  hidden?: boolean;
};

export type QuickLinkDropdown = {
  id: string; //used for specifying keys in lists. Should be unique
  type: QuickLinkType.DROPDOWN;
  items: Record<string, string>;
  default: number;
  description?: string;
  action?: Function;
  hidden?: boolean;
};

export type QuickLinkCustom = {
  id: string; //used for specifying keys in lists. Should be unique
  type: QuickLinkType.CUSTOM;
  icon?: ReactElement;
  description?: string;
  displayName?: string | ReactElement;
  onClick?: (...params) => void;
  hidden?: boolean;
};

export const QuickLinkItems = (
  menuBundle,
  isAnonymousUser: boolean,
): (
  | QuickLinkKatIcon
  | QuickLinkDropdown
  | QuickLinkSvg
  | QuickLinkCustom
)[] => {
  return [
    /* {
    id: '1',
    type: QuickLinkType.KAT_ICON,
    iconName: 'mail_outline',
    redirectUrl: '#',
    description: 'Email',
  },
  {
    id: '2',
    type: QuickLinkType.KAT_ICON,
    iconName: 'gear',
    redirectUrl: '#',
    description: 'Settings',
  },
  {
    id: '3',
    type: QuickLinkType.KAT_ICON,
    iconName: 'hint',
    redirectUrl: '#',
    description: 'Help',
  }, */
    {
      id: '4',
      type: QuickLinkType.CUSTOM,
      icon: <LanguagePicker />,
      description: 'Localization Dropdown',
    },
    {
      id: '5',
      type: QuickLinkType.CUSTOM,
      icon: <UserAvatar />,
      displayName: <UserName />,
      description: 'User',
      hidden: isAnonymousUser,
    },
    {
      id: '6',
      type: QuickLinkType.SVG,
      icon: <LogoutIcon />,
      onClick: (language) => {
        const authUrl = AuthUrlGeneration.generateSignoutUrl(
          language || 'en-US',
        );
        window.location.assign(authUrl);
      },
      description: menuBundle.getMessage(MenuConstants.SIGNOUT_MENU_NAME),
      hidden: isAnonymousUser,
    },
    {
      id: '7',
      type: QuickLinkType.KAT_ICON,
      iconName: 'person',
      onClick: (language) => {
        const authUrl = AuthUrlGeneration.generateAuthUrl(language || 'en-US');
        window.location.assign(authUrl);
      },
      description: menuBundle.getMessage(MenuConstants.LOGIN_MENU_NAME),
      hidden: !isAnonymousUser,
    },
  ];
};
